// removed by extract-text-webpack-plugin
module.exports = {"text-field":"TextField__text-field","textField":"TextField__text-field","clear-icon":"TextField__clear-icon","clearIcon":"TextField__clear-icon"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TextField/TextField.mobile.css
// module id = 1033
// module chunks = 8